
import { FormItem, FormLabel } from "@/components/ui/form";
import { UseFormReturn } from "react-hook-form";
import { LoanAmountSectionSv } from "./LoanAmountSectionSv";
import { LoanTermSectionSv } from "./LoanTermSectionSv";
import { LoanCalculationSummary } from "./LoanCalculationSummary";
import { FormValues } from "@/types/loan";
import { useIsMobile } from "@/hooks/use-mobile";
import { useEffect } from "react";
import { LoanPurposeField } from "./LoanPurposeField";

interface LoanDetailsSectionProps {
  form: UseFormReturn<FormValues>;
  loanAmount: number;
  setLoanAmount: (value: number) => void;
  loanTerm: number;
  setLoanTerm: (value: number) => void;
  monthlyPayment: number;
  totalPaid: number;
  interestAndFees: number;
  interest: number;
  setLoanType?: (value: string) => void;
}

export const LoanDetailsSectionSv = ({
  form,
  loanAmount,
  setLoanAmount,
  loanTerm,
  setLoanTerm,
  monthlyPayment,
  totalPaid,
  interestAndFees,
  interest,
  setLoanType = () => {}
}: LoanDetailsSectionProps) => {
  const isMobile = useIsMobile();
  
  // Set default loan type
  useEffect(() => {
    const currentLoanType = form.getValues().loanType;
    if (currentLoanType && setLoanType) {
      setLoanType(currentLoanType);
    } else {
      // Set default loan type if not present
      setLoanType("kulutusluotto");
    }
  }, [form, setLoanType]);
  
  return (
    <div className="p-3 md:p-5 bg-blue-50 rounded-lg w-full">
      <h3 className="text-lg font-medium text-blue-700 mb-3 md:mb-4">Låneuppgifter</h3>
      
      <LoanPurposeField form={form} language="sv" className="mb-4" />
      
      <LoanAmountSectionSv 
        loanAmount={loanAmount} 
        setLoanAmount={setLoanAmount} 
      />
      
      <LoanTermSectionSv 
        loanTerm={loanTerm} 
        setLoanTerm={setLoanTerm} 
      />
      
      <LoanCalculationSummary 
        monthlyPayment={monthlyPayment}
        totalPaid={totalPaid}
        interestAndFees={interestAndFees}
        interestRate={interest}
        monthlyFee={5}
        setupFee={150}
        language="sv"
      />
    </div>
  );
};
